import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class Panorama extends Component {

  CONTAINER_ELEMENT_ID = 'panoramaWrapper';

  MAP_ELEMENT_ID = 'panoramaMap';

  VIEW_ELEMENT_ID = 'panoramaView';

  form = null;

  panorama = null;

  buttons = {};

  inputs = {};

  isTourMode = false;

  configure() {
    return super.configure();
  }

  initialize() {

    this.form = $('.is-object-form');
    this.container = $(`#${this.CONTAINER_ELEMENT_ID}`);
    this.isTourMode = (this.form.hasClass('is-tour-mode'));

    this.start()
    return super.initialize();
  }

  start() {

    if (
      this.form.length !== 1
      || $(`#${this.MAP_ELEMENT_ID}`).length === 0
    ) {
      return false;
    }

    this.readInputs();
    this.readButtons();
    this.initPanorama();
    this.subscribeToEvents();
  }

  subscribeToEvents() {

    // Panorama manager listeners
    this.panorama.addListener('panoChanged',     (data) => {
      return this.setIdInputValue(data);
    });
    this.panorama.addListener('positionChanged', (data) => {
      return this.setCoordinatesInputValue(data);
    });
    this.panorama.addListener('headingChanged',  (data) => {
      return this.setHeadingInputValue(data);
    });
    this.panorama.addListener('pitchChanged',    (data) => {
      return this.setPitchInputValue(data);
    });

    // Buttons and checkbox listeners
    this.buttons.searchPanoramaByPositionPoint.on('click', (event) => {
      return this.searchByPositionPoint(event);
    });

    this.inputs.panoramaIsActive.on('change', (event) => {
      return this.onPanoramaActivityStatusChange(event);
    });

    let delayedAction = null;

    // Inputs listeners
    ['panoramaLat', 'panoramaLng', 'panoramaPitch', 'panoramaHeading', 'panoramaId']
      .forEach((field) => {
      this.inputs[field].on('change keyup',
        (
          (field) => {
            return () => {
              clearTimeout(delayedAction);
              delayedAction = setTimeout(() => {
                return this.onInputChanged(field)
              }, 500);
            };
          })(field)
      );
    });

  }

  readInputs() {

    this.form.find('input').each((index, element) => {
      element = $(element);
      if (element.attr('name') != null) {
        let name = $.snakeToCamelCase(element.attr('name'));
        this.inputs[name] = element;
      }
    });

  }

  readButtons() {

    this.form.find('button').each((index, element) => {
      element = $(element);
      if (element.attr('name') != null) {
        let name = $.snakeToCamelCase(element.attr('name'));
        this.buttons[name] = element;
      }
    });

  }

  onPanoramaActivityStatusChange(event) {

    let element = this.inputs.panoramaIsActive;

    if (element.prop('checked')) {

      // Show
      this.container.removeClass('is-hidden');
      setTimeout(() => {
        this.panorama.refresh();
      }, 100);

      if (Number(this.inputs.positionPointLat.val()) !== 0 && this.getCoordinatesInputValue().lat == 0) {
        return this.searchByPositionPoint();
      }

    } else {
      this.container.addClass('is-hidden');
    }

  }

  onInputChanged(field) {

    this.logger('onInputChanged field:', field);

    // If lat/lng was changed
    if (['panoramaLat', 'panoramaLng'].indexOf(field) >= 0) {

      // Reset panorama id
      this.setIdInputValue('');

      // Search by coordinates
      return this.panorama.searchByLocation(
        this.getCoordinatesInputValue(),
        (result) => {
        if (result != null) {
          return this.setPanoramaBySearchResult(result);
        }
      });

    } else if (field === 'panoramaId') {

      // If id changed and it's not empty
      if (this.getIdInputValue().length > 0) {

        return this.panorama.searchById(
          this.getIdInputValue(),
          (result) => {
          if (result != null) {
            return this.setPanoramaBySearchResult(result);
          }
        });

      } else {

        // If id is empty, try to find by coordinates
        return this.panorama.searchByLocation(
          this.getCoordinatesInputValue(),
          (result) => {
          if (result != null) {
            return this.setPanoramaBySearchResult(result);
          }
        });

      }

    } else if (['panoramaPitch', 'panoramaHeading'].indexOf(field) >= 0) {

      this.panorama.setPOV(
        this.getHeadingInputValue(),
        this.getPitchInputValue()
      );

    }

  }

  /**
   * Sets value for id input
   *
   * @param id
   * @param isWithChangeEvent
   */
  setIdInputValue(id, isWithChangeEvent) {
    this.inputs.panoramaId.val(id || '');

    if (typeof isWithChangeEvent === 'boolean' && isWithChangeEvent === true) {
      this.inputs.panoramaId.change(); // Only one is enough
    }

  }

  /**
   * Returns id value
   *
   * @returns {string|null}
   */
  getIdInputValue() {
    return this.inputs.panoramaId.val() || null;
  }

  /**
   * Sets values for coordinates input
   *
   * @param coordinates
   * @param isWithChangeEvent
   */
  setCoordinatesInputValue(coordinates, isWithChangeEvent) {
    this.inputs.panoramaLng.val(coordinates.lng || 0);
    this.inputs.panoramaLat.val(coordinates.lat || 0);

    if (typeof isWithChangeEvent === 'boolean' && isWithChangeEvent === true) {
      this.inputs.panoramaLng.change(); // Only one is enough
    }
  }

  /**
   * Returns coordinates values
   *
   * @returns {{lat: number, lng: number}}
   */
  getCoordinatesInputValue() {
    return {
      lat: Number(this.inputs.panoramaLat.val()) || 0,
      lng: Number(this.inputs.panoramaLng.val()) || 0
    }
  }

  /**
   * Sets value for heading
   *
   * @param heading
   * @param isWithChangeEvent
   */
  setHeadingInputValue(heading, isWithChangeEvent) {
    this.inputs.panoramaHeading.val(heading || 0);

    if (typeof isWithChangeEvent === 'boolean' && isWithChangeEvent === true) {
      this.inputs.panoramaHeading.change();
    }
  }

  /**
   * Returns heading value
   *
   * @returns {*|number}
   */
  getHeadingInputValue() {
    return parseFloat( this.inputs.panoramaHeading.val() || 0 );
  }

  /**
   * Sets value for pitch
   *
   * @param pitch
   * @param isWithChangeEvent
   */
  setPitchInputValue(pitch, isWithChangeEvent) {
    this.inputs.panoramaPitch.val(pitch || 0);

    if (typeof isWithChangeEvent === 'boolean' && isWithChangeEvent === true) {
      this.inputs.panoramaPitch.change();
    }
  }

  /**
   * Returns pitch value
   *
   * @returns {*|number}
   */
  getPitchInputValue() {
    return parseFloat( this.inputs.panoramaPitch.val() || 0 );
  }

  /**
   * Inits panorama
   *
   */
  initPanorama() {

    this.panorama = this.App.Panorama.Manager.create({
      map:  this.MAP_ELEMENT_ID,
      view: this.VIEW_ELEMENT_ID
    }, {
      config: {
        map: {
        },
        view: {
        }
      }
    });

    this.loadPanorama();

  }


  /**
   * Loads panorama by input values
   *
   * @returns {*}
   */
  loadPanorama() {

    // Try to find by panorama ID
    let trySearchByCurrentId = new Promise((resolve) => {
      if (this.getIdInputValue() != null && this.getIdInputValue().length > 0) {
        return this.searchByCurrentId(resolve);
      }
      return resolve(null);
    });

    // Try to search by coordinates
    let trySearchByCoordinates = new Promise((resolve) => {

      if (this.getCoordinatesInputValue().lat !== 0) {
        return this.searchByCurrentCoordinates(resolve);
      }
      return resolve(null);
    });

    // Finally search
    trySearchByCurrentId.then(() => {
      return trySearchByCoordinates;
    }).then((result) => {
      if (result != null) this.setPanoramaBySearchResult(result);
    });

  }

  searchByCurrentId(callback) {
    return this.panorama.searchById(
      this.getIdInputValue(),
      callback
    );
  }

  searchByCurrentCoordinates(callback) {
    return this.panorama.searchByLocation(
      this.getCoordinatesInputValue(),
      callback
    );
  }

  /**
   * Sets panorama by search result
   *
   * @param result
   */
  setPanoramaBySearchResult(result) {

    if (typeof result.id === 'string') {

      this.logger('Set panorama by id:', result.id);

      this.panorama.setId(result.id);

      if (this.getHeadingInputValue() === 0) {

        let heading = this.panorama.computeHeading(
          result.position,
          this.getViewPointCoordinates()
        );

        this.panorama.setPOV(
          heading,
          this.getPitchInputValue()
        );

      } else {
        this.panorama.setPOV(
          this.getHeadingInputValue(),
          this.getPitchInputValue()
        );
      }

      this.panorama.setCenter(result.position);

    }

  }

  getViewPointCoordinates() {
    return {
      lat: parseFloat(this.inputs.viewPointLat.val()),
      lng: parseFloat(this.inputs.viewPointLng.val())
    };
  }

  getPositionPointCoordinates() {
    return {
      lat: parseFloat(this.inputs.positionPointLat.val()),
      lng: parseFloat(this.inputs.positionPointLng.val())
    };
  }

  searchByPositionPoint() {

    let location = this.getPositionPointCoordinates();

    if (location.lat === 0 && location.lng === 0)
      return false;

    this.setCoordinatesInputValue(location, true);

  }

}